var file_upload_viewer_default = {
  "fontElementMap": "JhePZ",
  "file_upload_container": "DM3d4",
  "file_upload_link": "d0NAB",
  "file_upload_error_container": "HusNV",
  "file_upload_file_info": "k6oRG",
  "file_upload_type_icon": "nCT2D",
  "file_upload_status_icon_container": "aY9zF",
  "file_upload_status_icon": "g8ZKQ",
  "file_upload_description": "MwNw3",
  "file_upload_name_container": "az0oW",
  "file_upload_name": "S2TfW",
  "file_upload_extension": "YfRrB",
  "file_loader_icon": "uNq8v",
  "file_upload_icon_frame": "BpXin",
  "file_upload_icon_background": "HHfDP"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
